/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { useFormContext } from "react-hook-form";
import { petSpecies, strings } from "../../../common/Strings/Strings";
import { AutoCompleteOptions } from "../../../models/AutoCompleteOptions";
import Field from "../../../components/ReactHookFormFields/General/Field";
import { SpeciesRequest } from "../../../models/species/SpeciesRequest";
import CheckBox from "../../../components/ReactHookFormFields/General/CheckBox";
import Select from "../../../components/ReactHookFormFields/General/Select/Select";
import { SwedishSpeciesCategory } from "../../../models/species/SwedishSpeciesCategory";
import { PetVetDataSpeciesCategory } from "../../../models/species/PetVetDataSpeciesCategory";

const SpeciesForm: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SpeciesRequest>();

  return (
    <>
      <Field
        autoComplete={AutoCompleteOptions.off}
        error={errors.latinName}
        label={strings.latinName}
        name="latinName"
        register={register}
        required
      />
      <Field
        autoComplete={AutoCompleteOptions.off}
        error={errors.localizedNames?.en}
        label={`${strings.name} (EN)`}
        name={`localizedNames.[en]`}
        register={register}
        required
      />
      <Field
        autoComplete={AutoCompleteOptions.off}
        error={errors.localizedNames?.hu}
        name={`localizedNames.[hu]`}
        label={`${strings.name} (HU)`}
        register={register}
        required
      />
      <Field
        autoComplete={AutoCompleteOptions.off}
        error={errors.localizedNames?.sv}
        label={`${strings.name} (SV)`}
        name={`localizedNames.[sv]`}
        register={register}
        required
      />
      <CheckBox
        error={errors.isProducingAnimal}
        label={strings.isProducingAnimal}
        name="isProducingAnimal"
        register={register}
      />
      <Select
        autoComplete={AutoCompleteOptions.off}
        error={errors.swedishSpeciesCategory}
        isChooseOption={false}
        label={strings.swedishPrescriptionCategory}
        name="swedishSpeciesCategory"
        options={Object.values(SwedishSpeciesCategory).map((ps) => {
          return {
            value: ps as SwedishSpeciesCategory,
            title: petSpecies[ps],
          };
        })}
        register={register}
        required
      />
      <Select
        autoComplete={AutoCompleteOptions.off}
        error={errors.petVetDataSpeciesCategory}
        isChooseOption={false}
        label={strings.petVetDataSpeciesCategory}
        name="petVetDataSpeciesCategory"
        options={Object.values(PetVetDataSpeciesCategory).map((ps) => {
          return { value: ps as PetVetDataSpeciesCategory, title: petSpecies[ps] };
        })}
        register={register}
        required
      />
    </>
  );
};

export default SpeciesForm;